import style from './ErrorMessage.module.css';

const ErrorMessage = ({ message }) => <p className={style.ErrorMessage}>{message}</p>;

export default ErrorMessage;